import React from 'react';
import classNames from 'classnames';
import {
  FiDownload,
  FiExternalLink,
  FiMaximize,
  FiMinimize,
  FiMonitor,
  FiX,
} from 'react-icons/fi';
import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';
import { InitialsBadge } from '@components/InitialsBadge';
import styles from './ScreenshotViewerHeader.module.scss';

export const ScreenshotViewerHeaderComponent = ({
  title,
  dateLabel,
  timeLabel,
  employeeName,
  teamName,
  onDownload,
  imageHref,
  onToggleFullscreen,
  isFullscreen,
  onClose,
  className,
}) => {
  return (
    <div className={classNames(styles.header, className)}>
      <div className={styles.left}>
        <span className={styles.logo}>
          <FiMonitor size={16} />
        </span>
        <Text
          variant={textVariantsEnum.Text_13}
          fontWeight={fontWeightEnum.Bold}
          color="gray-900"
        >
          {title}
        </Text>
        {dateLabel && (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Normal}
            color="gray-400"
            className={styles.metaItem}
          >
            {dateLabel}
          </Text>
        )}
        {timeLabel && (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Normal}
            color="gray-400"
            className={styles.metaItem}
          >
            {timeLabel}
          </Text>
        )}
      </div>

      <div className={styles.right}>
        {employeeName && (
          <div className={styles.person}>
            <InitialsBadge label={employeeName} twoLetter />
            <Text
              variant={textVariantsEnum.Text_13}
              fontWeight={fontWeightEnum.Medium}
              color="gray-900"
            >
              {employeeName}
            </Text>
          </div>
        )}
        {teamName && (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Normal}
            color="gray-400"
            className={styles.metaItem}
          >
            {teamName}
          </Text>
        )}

        <div className={styles.actions}>
          {onDownload && (
            <button
              type="button"
              className={styles.iconButton}
              onClick={onDownload}
              aria-label="Download screenshot"
              title="Download"
            >
              <FiDownload size={18} />
            </button>
          )}
          {imageHref && (
            <a
              href={imageHref}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.iconButton}
              aria-label="Open in new tab"
              title="Open in new tab"
            >
              <FiExternalLink size={18} />
            </a>
          )}
          {onToggleFullscreen && (
            <button
              type="button"
              className={styles.iconButton}
              onClick={onToggleFullscreen}
              aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
              title={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}
            >
              {isFullscreen ? (
                <FiMinimize size={18} />
              ) : (
                <FiMaximize size={18} />
              )}
            </button>
          )}
          {onClose && (
            <button
              type="button"
              className={classNames(styles.iconButton, styles.closeButton)}
              onClick={onClose}
              aria-label="Close"
              title="Close"
            >
              <FiX size={20} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

ScreenshotViewerHeaderComponent.displayName = 'ScreenshotViewerHeader';
